export const SIRV_BASE_URL = "https://kobina.sirv.com/Images/kobina-koomson-w/";

export const BASE_URL = "https://kobina.me";

export const MAX_CLAPS_PER_CLIENT_TOTAL = 50; // maximum claps a single clientId can give per post
export const MAX_CLAPS_PER_MINUTE = 10; // maximum claps per client per minute
export const CLAPS_RATE_WINDOW_MS = 60 * 1000;
